import { initialize, formValueSelector } from 'redux-form';
import { push } from 'react-router-redux';
import { REHYDRATE } from 'redux-persist/constants';
import { APP_OFFLINE } from '../commons/initializers/initDucks';
import DocumentEntity from '../../../shared/src/entity/DocumentEntity';
import archivedDocumentsCollection from '../commons/rest/archivedDocumentsRest';
import { compareDocumentsForDisplay } from '../documents/documentsDucks';

export const SEARCH_FORM = 'bookSearch';

/**
 * =======================================
 * The actions
 * =======================================
 */
const SEARCH = 'SEARCH';

const SEARCH_HISTORY_START = 'SEARCH_HISTORY_START';
const SEARCH_HISTORY_SUCCESS = 'SEARCH_HISTORY_SUCCESS';
const SEARCH_HISTORY_FAILURE = 'SEARCH_HISTORY_FAILURE';

const SEARCH_RESET = 'SEARCH_RESET';

/**
 * =======================================
 * Selectors
 * =======================================
 */

const formSelector = formValueSelector(SEARCH_FORM);

/**
 * =======================================
 * The actions creators
 * =======================================
 */

const searchHistoryIfOnline = () =>
  (dispatch, getState) => {
    const offline = getState().appState.offline;
    const text = getState().search.text;
    if (offline) {
      return Promise.resolve();
    }

    dispatch({ type: SEARCH_HISTORY_START, payload: text });

    const params = {
      filters: ['text,' + text],
    };
    return archivedDocumentsCollection.getAll(params)
      .then((response) => {
        dispatch({ type: SEARCH_HISTORY_SUCCESS, payload: response.body(false) });
      })
      .catch(() => dispatch({ type: SEARCH_HISTORY_FAILURE }));
  };

export const searchDocuments = () => (dispatch, getState) => {
  const text = formSelector(getState(), 'text');
  dispatch({ type: SEARCH, payload: text });
  if (text) {
    dispatch(push('/search'));
    dispatch(searchHistoryIfOnline());
  } else {
    dispatch(push('/'));
    dispatch({ type: SEARCH_RESET });
  }
};

export const resetSearch = () =>
  (dispatch) => {
    dispatch({ type: SEARCH_RESET });
    dispatch(initialize('bookSearch', { text: '' }));
  };

/**
 * =======================================
 * The reducer for the search page.
 * =======================================
 */
const initialState = {
  text: '',
  historyDocuments: [],
  loading: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH:
      return {
        ...state,
        text: action.payload,
      };
    case APP_OFFLINE:
      return {
        ...state,
        historyDocuments: [],
      };
    case SEARCH_HISTORY_START:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_HISTORY_SUCCESS: {
      const historyDocuments = action.payload.map(doc => new DocumentEntity(doc).asHistory());
      historyDocuments.sort(compareDocumentsForDisplay);
      return {
        ...state,
        loading: false,
        error: false,
        historyDocuments,
      };
    }
    case SEARCH_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        historyDocuments: [],
      };
    case SEARCH_RESET:
      return {
        ...state,
        text: '',
        historyDocuments: [],
      };
    case REHYDRATE: {
      const oldSearch = action.payload.search;
      if (oldSearch && oldSearch.historyDocuments) {
        return {
          ...oldSearch,
          historyDocuments: oldSearch.historyDocuments.map(doc => new DocumentEntity(doc).asHistory()),
        };
      }
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/search/searchDucks.js